import { MAP_GRID } from './mapTypes'

/** The label estimate the layout and the tests share (spec §3.6). */
export function estimateWidth(text: string): number {
  return text.length * MAP_GRID.CHAR_W
}

/** Word-wrap to at most `maxChars` per line; a word longer than a line is hard-split. */
export function wrapText(text: string, maxChars: number): string[] {
  const max = Math.max(1, Math.floor(maxChars))
  const lines: string[] = []
  let line = ''
  for (const word of text.split(/\s+/).filter(Boolean)) {
    const pieces: string[] = []
    for (let i = 0; i < word.length; i += max) pieces.push(word.slice(i, i + max))
    for (const piece of pieces) {
      if (!line) line = piece
      else if (line.length + 1 + piece.length <= max) line += ` ${piece}`
      else {
        lines.push(line)
        line = piece
      }
    }
  }
  if (line) lines.push(line)
  return lines.length ? lines : ['']
}
